import { render, staticRenderFns } from "./OnboardDialog.vue?vue&type=template&id=15d750b1&"
import script from "./OnboardDialog.vue?vue&type=script&lang=js&"
export * from "./OnboardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports